import React from 'react';
import i18next from 'i18next';
import { observer } from 'mobx-react';
import { analytics } from 'core/analytics';
import { ComponentBaseProps } from 'types';
import { useCADManager } from 'hooks';
import { GeometryIcon, PartIcon } from 'icons';
import { insertDivider } from 'utils/jsxUtils';

type AnnotationItemProps = {
  text: React.ReactNode;
  icon: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
} & ComponentBaseProps;

export const AnnotationItem = ({
  text,
  icon,
  isActive,
  onClick,
  className = '',
}: AnnotationItemProps) => {
  return (
    <div
      className={`flex ${
        isActive ? 'text-wfBlue font-extrabold' : 'text-wfBlack'
      } cursor-pointer ${className}`}
      onClick={onClick}
    >
      <p className='text-sm mr-2'>{text}</p>
      {icon}
    </div>
  );
};

export const AnnotationWays = observer(() => {
  const {
    isActivePart,
    isActiveGeometry,
    showAnnotatePart,
    showAnnotateGeometry,
    shouldShowAnnotationWays,
    handleClickAnnotationPart,
    handleClickAnnotationGeometry,
  } = useCADManager();

  if (!shouldShowAnnotationWays) {
    return null;
  }

  return (
    <div className='flex'>
      {insertDivider(
        [
          showAnnotateGeometry && (
            <AnnotationItem
              text={i18next.t('Annotate Geometry')}
              isActive={isActiveGeometry}
              onClick={handleClickAnnotationGeometry}
              icon={
                <GeometryIcon
                  className={isActiveGeometry ? ' stroke-wfBlue ' : ''}
                />
              }
            />
          ),
          showAnnotatePart && (
            <AnnotationItem
              text={i18next.t('Annotate Part')}
              isActive={isActivePart}
              onClick={handleClickAnnotationPart}
              icon={
                <PartIcon className={isActivePart ? ' stroke-wfBlue' : ''} />
              }
            />
          ),
        ],
        { divider: <div className='mx-2' /> },
      )}
    </div>
  );
});
